import { Component, OnInit } from '@angular/core';
import { DataService } from "../services/dataservice.service";
import { DateService } from "../services/dateservice.service";
import { DateModel } from "../services/date.model";

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  private slides: any[];
  public dates: DateModel[] = [];
  private intro: string = '';
  private sponsorMessage: string = '';

  constructor(private dataService: DataService, private dateService: DateService) {

    this.dataService.dataServiceArrived.subscribe(
      (data) =>
      {
        this.intro = data.filter((data) => {return data.Type == 'intro-home'})[0].Content;
        this.sponsorMessage = data.filter((data) => {return data.Type == 'sponsor-message'})[0].Content;
      }
    )
    this.dateService.dateSubject.subscribe(
      (dates: DateModel[]) => {
        this.dates = dates;
      }
    )
  }

  ngOnInit() {
    this.slides = [{ src: './assets/img/bay_1200_500.jpg', label: '', content: ''}];
    this.dataService.getContent();
    this.dateService.getDates();
  }

  addSlide() {
    this.slides.push({ src: 'https://lorempixel.com/1000/500?r=1', label: 'hahamore', content: 'bonkmore'});
  }

}



// WEBPACK FOOTER //
// ./src/app/main/home/home.component.ts